
import { useExternalMedia } from "../../../../hooks/useExternalMedia";
import { IHeaderType } from "../../../../types/types";
import { Colors } from "../../../../utils/colors/colors";
import Title from "../../../../utils/title/Title";




export default function ContactFormSide() {


  const { valuePropsBg } = useExternalMedia();
  const {
    whiteColor
  } = Colors();

  return (
    <div
      data-aos="fade-up"
      data-aos-once="true"
      className="contact-side-bg"
      style={{
        background: `linear-gradient(0deg, rgba(18, 17, 43, 0.9), rgba(18, 17, 43, 0.9)), url(${valuePropsBg})`,
      }}
    >
      <Title
        textColor={whiteColor}
        text={"Want to get in touch? We are eager to hear from you."}
        style={{
          margin: "4rem",
          maxWidth: "525px"
        }}
        type={IHeaderType.h2}
      />
    </div>
  );
}
